export const isAllItemSelected = (availableItems, setIsSelectionInProgress) => {
	let counter = 1;
	let isSelectionInProgress = setInterval(() => {
		let checkedItem = document.querySelectorAll(`[id^="AvailableItems_Selected"]`)?.length;
		if (availableItems == checkedItem) {
			setIsSelectionInProgress(false);
			clearInterval(isSelectionInProgress);
		} else {
			counter = counter + 1;
		}
		if (counter == 50) { // timeout if selection takes more than 10 sec
			setIsSelectionInProgress(false);
			clearInterval(isSelectionInProgress);
		}
	}, 200);
};

export const isAllItemUnSelected = (setIsSelectionInProgress) => {
	let counter = 1;
	let isUnselectionInProgress = setInterval(() => {
		let checkedItem = document.querySelectorAll(`[id^="AvailableItems_Selected"]`)?.length;
		if (checkedItem == 0) {
			setIsSelectionInProgress(false);
			clearInterval(isUnselectionInProgress);
		} else {
			counter = counter + 1;
		}
		if (counter == 50) { // timeout if unselection takes more than 10 sec
			setIsSelectionInProgress(false);
			clearInterval(isUnselectionInProgress);
		}
	}, 200);
};